import React from 'react'

const NotFoundPage = () => {
	return <div className="notFound">Page could not be found...</div>
}

export default NotFoundPage
